// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="-5010 525 24.079 14"><path fill="#c7c4c4" d="M-4986.161 531.3c-.3-.2-5.4-6.3-11.8-6.3s-11.6 6.1-11.8 6.4a1.048 1.048 0 00-.1 1.2c.2.2 4.4 6.4 11.9 6.4 7.4 0 11.7-6.2 11.9-6.5a1.063 1.063 0 00-.1-1.2zm-11.8 5.7c-5.1 0-8.5-3.5-9.7-4.9 1.4-1.5 5.3-5.1 9.7-5.1s8.3 3.6 9.7 5c-1.2 1.5-4.6 5-9.7 5zm0-9a4 4 0 104 4 4.012 4.012 0 00-4-4zm0 6a2 2 0 112-2 2.006 2.006 0 01-2 2z"/></svg>
);

export default fn;
